export default class GameStateUI {

    constructor(state, group) {
        this.state = state;
        this.yearsLeftLabel = game.add.bitmapText(game.world.width/2-170, -90, "nokia", "", 26, group);
        this.energyBitmap = game.add.bitmapData(500, 40);
        this.energyBitmap.fill(100,0,0);
        this.energySprite = game.add.sprite(game.world.width/2-this.energyBitmap.width/2, game.world.height+60, this.energyBitmap, 0, group);
        this.history = []

        this.logLines = [
            game.add.bitmapText(0, game.world.height + 110, "nokia", "", 26, group),
            game.add.bitmapText(0, game.world.height + 140, "nokia", "", 26, group),
        ];

        for (let l of this.logLines) {
            l.maxWidth = game.world.width;
        }

        this.nextEventLabel = game.add.bitmapText(game.world.width/2-200, -120, "nokia", "", 20, group);
        this.nextEventLabel.tint = 0xc2893c;
        this.nextEventLabel.visible = false;
        this.dialogsPredicted = 0;
    }

    update() {
        if (game.narrator.nextEventTime <= 0 && this.state.hero.holding && this.nextEventLabel.visible) {
            this.nextEventLabel.text = (this.dialogsPredicted > 1 ? "One more stupid dialog" : "Stupid dialog") + " as soon as you drop the " + this.state.hero.holding.constructor.label;
        }
        else if (game.narrator.nextEventTime > 0 && game.narrator.nextEventTime < 5) {
            if (!this.nextEventLabel.visible) {
                this.nextEventLabel.visible = true;
                this.nextEventLabel.alpha = 0;
                this.nextEventLabel.x = game.world.width/2 + 400;
                //game.add.tween(this.nextEventLabel).to({x:game.world.width/2-120}, 3000, null, true);
                game.add.tween(this.nextEventLabel).to({alpha: 1}, 1000, null, true);
                this.dialogsPredicted++;
            }
            this.nextEventLabel.text = (this.dialogsPredicted > 1 ? "One more stupid dialog" : "Stupid dialog") +" in " + game.narrator.nextEventTime + "s";
            if (this.state.howMuchTimeToFly() === 0) {
                this.nextEventLabel.text += " (if you put something to the furnace)";
            }
        } else {
            if (this.nextEventLabel.visible) {
                this.nextEventLabel.visible = false;
            }
        }
        if (this.nextEventLabel.visible) {
            this.nextEventLabel.targetX = game.world.width/2 - this.nextEventLabel.width/2;
            if (this.nextEventLabel.x !== this.nextEventLabel.targetX) {
                let delta = Math.sign(this.nextEventLabel.targetX - this.nextEventLabel.x) * 3;
                if (Math.abs(delta) > Math.abs(this.nextEventLabel.targetX - this.nextEventLabel.x)) {
                    delta = this.nextEventLabel.targetX - this.nextEventLabel.x;
                }
                this.nextEventLabel.x += delta;
            }
        }
        this.yearsLeftLabel.text = this.state.distanceLeft.toFixed(2) + " Light years to go";
        this.drawEnergy();
        this.drawLog();
    }

    drawLog() {
        let log = this.state.log;
        let last = log[log.length-1];
        if (last && !last.old) {
            last.printed = last.text.substr(0, last.printed.length + 1);
            this.logLines[1].text = last.printed;
            this.logLines[1].tint = 0x328CF0;
        } else {
            this.logLines[1].text = "";
        }
        let preLast = last && last.old ? last : log[log.length-2];
        if (preLast) {
            this.logLines[0].text = preLast.text;
            this.logLines[0].tint = 0x162533;
        } else {
            this.logLines[0].text = "";
        }

        this.logLines[1].y = this.logLines[0].y + this.logLines[0].height + 5;
    }

    drawEnergy() {
        const SINGLE = 5;
        let ints = Math.floor(this.state.energy / SINGLE) * SINGLE;
        let frac = this.state.energy - ints;
        this.energyBitmap.clear();
        this.drawSegment(0, ints, "#94181F", 1);
        this.drawSegment(ints, 100, "#1E1414", 1);
        this.drawSegment(ints, ints+SINGLE, "#94181F", frac / SINGLE);
        if (this.state.getHoldingEnergy()) {
            this.drawSegment(ints, ints + this.state.getHoldingEnergy(), "#fff000");
        }
        this.energyBitmap.dirty = true;
    }

    drawSegment(from, to, color, alpha = 1) {
        let ctx = this.energyBitmap.ctx;
        ctx.fillStyle = color;
        ctx.globalAlpha = alpha;
        let height = this.energyBitmap.height;
        let h3 = (height / 3)|0;
        let x0 = (this.energyBitmap.width * (to/100)) | 0;
        let x1 = (this.energyBitmap.width * (from/100)) | 0;
        ctx.beginPath();
        ctx.moveTo(x0 - 6, 0);
        ctx.lineTo(x0 - 6, h3);
        ctx.lineTo(x0, h3);
        ctx.lineTo(x0, height-h3);
        ctx.lineTo(x0 - 6, height-h3);
        ctx.lineTo(x0 - 6, height);
        ctx.lineTo(x1 - 6, height);
        ctx.lineTo(x1 - 6, height-h3);
        ctx.lineTo(x1, height-h3);
        ctx.lineTo(x1, h3);
        ctx.lineTo(x1 - 6, h3);
        ctx.lineTo(x1 - 6, 0);
        ctx.fill();
    }
}


// WEBPACK FOOTER //
// ./src/states/ui/game_state_ui.js